import React from 'react';
import './Intro.css';
import Github from '../../img/github.png';
import LinkedIn from '../../img/linkedin.png';
import { Link } from 'react-scroll';
const Intro = () => {
  return (
    <div className="intro">
        <div className="i-left">
            <div className="i-name">
                <span>Hey! I Am</span>
                <span>Ausner</span>
                <span>Miranda</span>
                <span>High experienced Software Engineer from Costa Rica. Full Stack Developer with high level of experience in web development, producing quality work.
                </span>
            </div>
            <Link spy={true} to={'Contact'} smooth={true}>
                 <button className="button i-button">Hire me!</button>
            </Link> 

            <div className="i-icons">
                <a href='http://cr.linkedin.com/in/ausner-miranda' target='blank'>
                    <img src={LinkedIn} draggable={false} alt="" />
                </a>
                <a href='https://github.com/Ausner' target='blank'>
                    <img src={Github} draggable={false} alt="" />
                </a>
            </div>

        </div>
        <div className="i-right">
            <div className="hero-visual" aria-label="Full stack development illustration">
                <div className="orbit orbit-one"></div>
                <div className="orbit orbit-two"></div>

                <div className="code-window">
                    <div className="window-dots">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                    <div className="code-lines">
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>

                <div className="laptop-card">
                    <div className="profile-panel">
                        <div className="avatar-dot"></div>
                        <span></span>
                        <span></span>
                    </div>
                    <div className="keyboard"></div>
                </div>

                <div className="tech-chip html">HTML</div>
                <div className="tech-chip css">CSS</div>
                <div className="tech-chip braces">{'{ }'}</div>
                <div className="code-chip">&lt;/&gt;</div>

                <div className="floating-card top-card">
                    <span className="badge-icon">#</span>
                    <span>Full Stack<br/>Developer</span>
                </div>
                <div className="floating-card bottom-card">
                    <span className="badge-icon">+</span>
                    <span><strong>Experienced</strong><br/>Software Engineer</span>
                </div>
            </div>
        </div>

        <div className="tech-strip" aria-label="Technologies and tools carousel">
            <span>Technologies &amp; Tools</span>
            <div className="tech-marquee">
                <div className="tech-track">
                    <p>Angular - React - Next.js - Java - C++ - TypeScript - Node.js - NestJS - MongoDB - Python - Flask - FastApi - AWS - Jenkins - Automate - N8N - Make - Tailwind CSS - </p>
                    <p aria-hidden="true">Angular - React - Next.js - TypeScript - Node.js - NestJS - MongoDB - Python - AWS - Jenkins - Automate - N8N - Make - Tailwind CSS - Bootstrap - Backend - Frontend - FullStack </p>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Intro
